import moment from 'moment'
import React,{useState,useEffect} from 'react'
import { Attendance } from '../../sdk'
import { Loader } from '../Default'
import { DataTable } from '../Default/DataTables/DataTable'
import { toasterFunction } from '../Default/ToasterComponent'

import { Iframe } from './Iframe'
export const MainContent=()=> {
  const [state,setState]=useState({loader:true,date:moment().format("yyyy-MM-DD"),type:0,data:[],tbHeader:[{title:"Employee Id",name:"time"},{title:"Employee Name",name:"cameraName"},{title:"Date",name:"lpValue"},{title:"Check in",name:"lpValue"},{title:"Check Out",name:"lpImage"}],updated:false,tableLoader:true,
  startTime:"",
  endTime:"",
  camType:1
});
  const apiData=async()=>{
    try{
    let arr=[];
    
    let result=await new Attendance().getLiveAttendance();
    if(result.length){
      for(let val of result){
        arr.push([val.employeeId,val.employeeName,val.date,val.checkIn?val.checkIn:"",val.checkOut?val.checkOut:""])
        
       }
    }
    
    setState((pre)=>{
      return {...pre,data:arr,loader:false}
    })

   
    }catch(e){
    alert("error occur")
    }

}

const onHandler=(event)=>{

  let name=event.target.name;
  let value=event.target.value;
  setState(pre=>{
    return {...pre,[name]:value}
  })
}
const onSubmit=async()=>{
  try{
//     if(state.startTime > state.endTime){
//       alert("start time must be less than");
//       return false;
// }
  await new Attendance().setTime({startTime:state.startTime,endTime:state.endTime});
  toasterFunction.success("time has been set");

}catch(e){

  }
}
const changeType=(camType)=>{
  setState((pre)=>{
    return {...pre,camType}
  })
  }
useEffect(()=>{
  apiData();
  const setTime=setInterval(()=>apiData(),1000 *2)
  return ()=>{
    clearInterval(setTime);
  }
  
 

},[])
if(!state.loader){
return (
    <>
      <div className="card mb-3">
       {/* BEGIN card-body */}
       <div className="card-body">
   <div className="col-12">
     <div className="row">
       <div className="col-6">
       <div className="fw-bold mb-3">
   <span className="flex-grow-1 text-white">Live Attendance</span>
   </div> 
       </div>
       {/* <div className="col-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" >Start Time</label>
        <input type="time" name="startTime" value={state.startTime} onChange={onHandler}/>

          </div>
       </div>
       <div className="col-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" >End Time</label>
        <input type="time" name="endTime" value={state.endTime} onChange={onHandler}/>

          </div>
       </div>
       <div className="col-2">
       <button type="button" class="btn btn-theme" onClick={onSubmit}>Submit</button>
        
       </div> */}
       {/* <div className="col-2">
   <DatePicker type="Anpr" date={moment().subtract(1, 'day').format()} startDate={moment("2017").startOf('year').format()} endDate={moment().subtract(1, 'day').format()} handler={onHandlerMonth}/>
   </div> */}
     </div>
  
   </div>
   {state.tableLoader && <><Loader/></>}
   <div className="col-12">
    <div className="row">
    {/* <div className="col-12 col-md-12 col-lg-5">
  <DataTable headers={state.tbHeader} data={state.data} image={true} updated={state.updated}/>
  
   </div> */}
   <div class="col-12 col-md-12 col-lg-12">
            <div class="card mb-3">
            <div class="card-header fw-bold small" style={{textAlign:"center"}}>live Stream</div>
            <div class="card-body" >
<Iframe camType={state.camType}/>
<div className="col-12" >
  <div className="row">
    {Array(8).fill(1).map((val,index)=>{
      return (<>
       <div className="col-1" style={{width:"12.5%",textAlign:"center"}}>
    <button type="button" class="btn btn-theme" onClick={()=>changeType(index + val)}>{window.env[`REACT_APP_Live_Stream_Name${index + val}`]}</button>
    </div>
      
      </>)
    })}
   
    
  </div>
       
       
       </div>
           </div><div class="card-arrow"><div class="card-arrow-top-left"></div><div class="card-arrow-top-right"></div><div class="card-arrow-bottom-left"></div><div class="card-arrow-bottom-right"></div></div></div>









           
                </div>
    </div>
   </div>

  
   </div>
   <div className="card-arrow">
         <div className="card-arrow-top-left" />
         <div className="card-arrow-top-right" />
         <div className="card-arrow-bottom-left" />
         <div className="card-arrow-bottom-right" />
       </div>
   </div>
   <div class="modal" id="showImg">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      
      <div class="modal-body">
       <img id="modalImage" src='' alt="nothing" style={{width:"100%"}}/>
      </div>
     
    </div>
  </div>
</div>


 </>
 
    
   )
}
else{
  return (<>
  <Loader/>
  </>)
}
  
}
